if (!customElements.get('tr-gift-card-preview-modal')) {
  class TrGiftCardPreviewModal extends HTMLElement {
    selectors = {
      closeButtons: '[data-tr-js-gift-card-preview-close]',
      dialog: '[data-tr-js-gift-card-preview-dialog]',
      image: '[data-tr-js-gift-card-preview-variant-image]',
      message: '[data-tr-js-gift-card-preview-message]',
      variant: '[data-tr-js-gift-card-variant-id]',
      messageInput: '[data-tr-js-gift-card-message]',
      openButton: '[data-tr-js-gift-card-preview-open]'
    };

    attributes = {
      variant: 'data-tr-js-gift-card-variant-id',
      image: 'data-tr-js-gift-card-preview-variant-image',
      messageDefault: 'data-tr-js-gift-card-preview-default-message'
    };

    stateClasses = {
      bodyOverflowHidden: 'overflow-hidden'
    };

    onVariantChangeUnsubscriber = undefined;

    connectedCallback() {
      this.dialogElement = this.querySelector(this.selectors.dialog);
      this.closeButtonElements = [...this.querySelectorAll(this.selectors.closeButtons)];
      this.imageElements = [...this.querySelectorAll(this.selectors.image)];
      this.messageElement = this.querySelector(this.selectors.message);
      this.bodyElement = document.body;
      this.isBodyScrollLocked = false;
      this.productInfoElement = this.closest('product-info');
      this.variantElements = this.productInfoElement ? [...this.productInfoElement.querySelectorAll(this.selectors.variant)] : [];
      this.selectedVariantId = this.variantElements.find((variantElement) => variantElement.checked)?.getAttribute(
        this.attributes.variant
      );
      this.messageInputElement = this.productInfoElement?.querySelector(this.selectors.messageInput);
      this.openButtonElement = this.productInfoElement?.querySelector(this.selectors.openButton);

      this.init();
      this.bindEvents();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      this.updatePreview();
    }

    bindEvents() {
      this.openButtonElement?.addEventListener('click', this.onOpenButtonClick);
      this.closeButtonElements.forEach((closeButtonElement) => closeButtonElement.addEventListener('click', this.onCloseButtonClick));
      this.dialogElement?.addEventListener('click', this.onDialogClick);
      this.dialogElement?.addEventListener('close', this.onDialogClose);
      this.messageInputElement?.addEventListener('input', this.onMessageInput);
      this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
    }

    onOpenButtonClick = () => {
      this.updatePreview();
      this.lockBodyScroll();
      this.dialogElement?.showModal();
    };

    onCloseButtonClick = () => {
      this.dialogElement?.close();
    };

    onDialogClick = (event) => {
      if (event.target === this.dialogElement) this.dialogElement.close();
    };

    onDialogClose = () => {
      this.unlockBodyScroll();
    };

    onMessageInput = () => {
      this.updateMessage();
    };

    onVariantChange = ({ data: { sectionId, variant } }) => {
      if (sectionId !== this.productInfoElement?.dataset.section || !variant) return;

      this.selectedVariantId = String(variant.id);
      this.updateImage();
    };

    updatePreview() {
      this.updateMessage();
      this.updateImage();
    }

    updateMessage() {
      const message = this.messageInputElement?.value.trim() || this.messageElement?.getAttribute(this.attributes.messageDefault) || '';

      this.messageElement.textContent = message;
      this.messageElement.hidden = message === '';
    }

    updateImage() {
      const selectedImageElement = this.imageElements.find(
        (imageElement) => imageElement.getAttribute(this.attributes.image) === this.selectedVariantId
      );
      const imageToDisplay = selectedImageElement || this.imageElements[0];

      this.imageElements.forEach((imageElement) => {
        imageElement.hidden = imageElement !== imageToDisplay;
      });
    }

    lockBodyScroll() {
      if (this.isBodyScrollLocked) return;

      this.bodyOverflowWasHidden = this.bodyElement.classList.contains(this.stateClasses.bodyOverflowHidden);
      this.bodyElement.classList.add(this.stateClasses.bodyOverflowHidden);
      this.isBodyScrollLocked = true;
    }

    unlockBodyScroll() {
      if (!this.isBodyScrollLocked) return;

      if (!this.bodyOverflowWasHidden) this.bodyElement.classList.remove(this.stateClasses.bodyOverflowHidden);

      this.isBodyScrollLocked = false;
    }

    destroy() {
      this.openButtonElement?.removeEventListener('click', this.onOpenButtonClick);
      this.closeButtonElements.forEach((closeButtonElement) => closeButtonElement.removeEventListener('click', this.onCloseButtonClick));
      this.dialogElement?.removeEventListener('click', this.onDialogClick);
      this.dialogElement?.removeEventListener('close', this.onDialogClose);
      this.messageInputElement?.removeEventListener('input', this.onMessageInput);
      this.onVariantChangeUnsubscriber?.();
      this.unlockBodyScroll();
    }
  }

  customElements.define('tr-gift-card-preview-modal', TrGiftCardPreviewModal);
}
